var LinkedConfirmationFactory = function ($resource, $window) {
  var retrieveNextDestination =
    "/participant-web-services/rest/partialauth/oneId/retrieveNextDestination";

  return {
    retrieveNextDestination: $resource(
      __baseApiUrl__ + retrieveNextDestination,
      {},
      {
        query: {
          method: "GET"
        },
      }
    ),
  };
};

LinkedConfirmationFactory.$inject = ["$resource", "$window"];
export default LinkedConfirmationFactory;
